import { scope } from '#components/generics/js/selectors/scope.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import invoke from '@mailobj-browser/front/js/tree/invoke.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import alert from '#utilities/js/ea/alert.js'
import { permissions, request } from '#utilities/js/ea/permissions.js'
import { app } from '#utilities/js/ea/skins.js'
import * as constraints from '#utilities/js/media/constraints.js'
import { get, stop } from '#utilities/js/media/stream.js'
import { elements } from './../../../styles.js'

const showWaiting = () => {
  const template = one(`.${elements.thread_top} .${elements.call} template`)
  const { document } = defaults
  const { body } = document
  let rendered

  if (template) {
    rendered = invoke(template)

    if (rendered) {
      const { firstChild } = rendered
      firstChild.classList.add(elements.meet)
      append(body, firstChild)
      return firstChild
    }
  }
  return null
}

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button,
    event
  ) => {
    const { root, window } = defaults
    const scopeProps = scope(button)
    const { err_perm } = scopeProps
    const wait = showWaiting(button)
    const { dataset } = root
    const { skin } = dataset

    try {
      if (skin === app) {
        const {
          MODIFY_AUDIO_SETTINGS,
          RECORD_AUDIO,
          CAMERA,
          WAKE_LOCK,
        } = permissions()
        await request([MODIFY_AUDIO_SETTINGS, RECORD_AUDIO, CAMERA, WAKE_LOCK])
      }
      const media = await get(window, constraints.audioAndVideo)

      if (media) {
        for (const track of media.getTracks()) {
          stop(track)
        }

        const callButton = button.nextElementSibling
        if (callButton) {
          callButton.dispatchEvent(event)
        } else {
          if (wait) {
            remove(wait)
          }
          await alert(err_perm)
        }
      }
    } catch (e) {
      if (wait) {
        remove(wait)
      }
      await alert(err_perm)
    }
  }
})

export default button => {
  onClick.listen(button)
}
